__turbopack_context__.v({
  "amount": "profile-payment-card-module-scss-module__8EIb9G__amount",
  "amount-text": "profile-payment-card-module-scss-module__8EIb9G__amount-text",
  "body": "profile-payment-card-module-scss-module__8EIb9G__body",
  "submit": "profile-payment-card-module-scss-module__8EIb9G__submit",
  "submit-wrapper": "profile-payment-card-module-scss-module__8EIb9G__submit-wrapper",
  "wrapper": "profile-payment-card-module-scss-module__8EIb9G__wrapper",
});
